/**
 * 显示或隐藏页面功能卡片
 * cookie 记录用户设定的行为
 */
// 默认隐藏卡片,删除为默认显示
// console.log($.cookie('__WWW_CARD__DISSTATUS__'));
if (typeof $.cookie('__WWW_CARD__DISSTATUS__') === 'undefined'){$.cookie('__WWW_CARD__DISSTATUS__', 'false', { expires: 365 });}
function showHideCard() {
  var __WWW_CARD__DISSTATUS__ = '__WWW_CARD__DISSTATUS__';
  if ($.cookie(__WWW_CARD__DISSTATUS__) === 'false') {
    $('.sMain').show();
    $('.chinaso_mian').show();
    $('.indexRoot').show();
    $('.logo').removeClass('logopadding');
    $('#showCard').hide();
    $('#hideCard').show();
    $('.search_box').addClass('search_box_show');
    $('.indexMain').addClass('indexMain_show');
    $('.qieHuanWrap-v3').show();
    $('.indexMain').trigger('main:resizeHeight');
    $('.indexMain').css('min-height', 960);
    $('.footer_index').attr('style','position:absolute');
    // $(".indexMain").css("height", T.setWrapperHeight());
  } else {
    $('.indexMain').css('min-height', 500);
    // if ($('body').height() > 960) {
    //   $('.indexMain').css('padding-bottom', '0');
    // } else {
    //   $('.indexMain').css('padding-bottom', '70px');
    // }
    $('#hideCard').hide();
    $('#showCard').show();
    $('.search_box').addClass('search_box_hide');
    $('.qieHuanWrap-v3').hide();
    $('.footer_index').attr('style', 'position:absolute');
  }

  $('#hideCard').click(function () {
    $('.qieHuanWrap-v3').hide();
    $('.indexMain').removeClass('indexMain_show');
    $('.indexMain').css('min-height', 500);
    // if ($('body').height() > 500) {
    //   $('.indexMain').css('padding-bottom', '0');
    // } else {
    //   $('.indexMain').css('padding-bottom', '0px');
    // }
    $.cookie(__WWW_CARD__DISSTATUS__, 'true', {expires: 365});
    $('#hideCard').hide();
    $('#showCard').show();
    $('.footer_index').attr('style','position:absolute');
    $('.indexMain').trigger('main:resizeHeight');
    // hotTrace.stopPlay();
  });

  $('#showCard').click(function () {
    $('.qieHuanWrap-v3').show();
    $('.indexMain').css('min-height', 960);
    $('.indexMain').addClass('indexMain_show');
    $.cookie(__WWW_CARD__DISSTATUS__, 'false', {expires: 365});
    $('#hideCard').show();
    $('#showCard').hide();
    $('.indexMain').trigger('main:resizeHeight');
    console.log($('body').height());
    if ($('.qieHuan:eq(0)').is(':visible') && $('.toutiao_l_list').size() > 3 && $('.toutiao_l_list').size() <= 5 && $(window).height() < 1020 || $('.qieHuan:eq(0)').is(':visible') && $('.toutiao_l_list').size() > 5) {
      $('.footer_index').attr('style','position:static');
    } else {
      $('.footer_index').attr('style','position:absolute');
    }
    // if ($('.qieHuan:eq(1)').is(':visible')) {
    //   hotTrace.autoPlay();
    // } else {
    //   hotTrace.stopPlay();
    // }
    //热点追踪滚轴
    $(".scrollDiv").scrollbar({contentCls:"scrollUl"});
  });
}
module.exports = showHideCard;



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/show_hide_card.js
// module id = 10d386cd56b16d1a4077
// module chunks = 1